import { SistLogo } from "./SistLogo";

export const Wordmark = ({ size = "md", inverted = false, tagline = true }) => (
  <SistLogo size={size} inverted={inverted} tagline={tagline} />
);
